import React from 'react';
import { CheckCircle } from 'lucide-react';

interface ThankYouProps {
  visible: boolean;
  onClose: () => void;
  title?: string;
  message?: string;
  buttonLabel?: string;
}

const ThankYou: React.FC<ThankYouProps> = ({
  visible,
  onClose,
  title = 'Thank You!',
  message = "We've received your enquiry and will get back to you shortly with more details and photos that match your colour choices.",
  buttonLabel = 'Close',
}) => {
  if (!visible) return null;
  
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div 
        className="bg-white rounded-lg shadow-xl p-8 max-w-md w-full animate-scale-up"
        style={{ 
          animation: 'scale-up 0.3s ease-out forwards',
        }}
      >
        <div className="text-center">
          <CheckCircle className="w-16 h-16 text-green-500 mx-auto mb-4" />
          
          <h2 className="text-2xl font-medium text-stone-800 mb-3">
            {title}
          </h2>
          
          <p className="text-stone-600 mb-6">
            {message}
          </p>
          
          <button
            onClick={onClose}
            className="px-6 py-2 bg-stone-800 text-white rounded-md hover:bg-stone-700 transition-all"
          >
            {buttonLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ThankYou;
